// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QuitOutlinedSvg from "@fishx/icons-svg/es/asn/QuitOutlined";
import FishxIcon from '../components/FishxIcon';

var QuitOutlined = function QuitOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: QuitOutlinedSvg
  }));
};

QuitOutlined.displayName = 'QuitOutlined';
export default React.forwardRef(QuitOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/QuitOutlined.js
// module id = 3953
// module chunks = 0